/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckArrivalPoint } from './PaxCheckArrivalPoint';
import {
    PaxCheckArrivalPointFromJSON,
    PaxCheckArrivalPointFromJSONTyped,
    PaxCheckArrivalPointToJSON,
    PaxCheckArrivalPointToJSONTyped,
} from './PaxCheckArrivalPoint';
import type { PaxCheckTransitPoint } from './PaxCheckTransitPoint';
import {
    PaxCheckTransitPointFromJSON,
    PaxCheckTransitPointFromJSONTyped,
    PaxCheckTransitPointToJSON,
    PaxCheckTransitPointToJSONTyped,
} from './PaxCheckTransitPoint';
import type { PaxCheckDeparturePoint } from './PaxCheckDeparturePoint';
import {
    PaxCheckDeparturePointFromJSON,
    PaxCheckDeparturePointFromJSONTyped,
    PaxCheckDeparturePointToJSON,
    PaxCheckDeparturePointToJSONTyped,
} from './PaxCheckDeparturePoint';

/**
 * Journey record (departure, transit, arrival) - API output
 * @export
 * @interface PaxCheckJourney
 */
export interface PaxCheckJourney {
    /**
     * Departure flight numbers
     * @type {Array<string>}
     * @memberof PaxCheckJourney
     */
    flightNumbers?: Array<string> | null;
    /**
     * 
     * @type {PaxCheckDeparturePoint}
     * @memberof PaxCheckJourney
     */
    departure: PaxCheckDeparturePoint;
    /**
     * List of transit points
     * @type {Array<PaxCheckTransitPoint>}
     * @memberof PaxCheckJourney
     */
    transit: Array<PaxCheckTransitPoint>;
    /**
     * 
     * @type {PaxCheckArrivalPoint}
     * @memberof PaxCheckJourney
     */
    arrival: PaxCheckArrivalPoint;
}

/**
 * Check if a given object implements the PaxCheckJourney interface.
 */
export function instanceOfPaxCheckJourney(value: object): value is PaxCheckJourney {
    if (!('departure' in value) || value['departure'] === undefined) return false;
    if (!('transit' in value) || value['transit'] === undefined) return false;
    if (!('arrival' in value) || value['arrival'] === undefined) return false;
    return true;
}

export function PaxCheckJourneyFromJSON(json: any): PaxCheckJourney {
    return PaxCheckJourneyFromJSONTyped(json, false);
}

export function PaxCheckJourneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckJourney {
    if (json == null) {
        return json;
    }
    return {
        
        'flightNumbers': json['flight_numbers'] == null ? undefined : json['flight_numbers'],
        'departure': PaxCheckDeparturePointFromJSON(json['departure']),
        'transit': ((json['transit'] as Array<any>).map(PaxCheckTransitPointFromJSON)),
        'arrival': PaxCheckArrivalPointFromJSON(json['arrival']),
    };
}

export function PaxCheckJourneyToJSON(json: any): PaxCheckJourney {
    return PaxCheckJourneyToJSONTyped(json, false);
}

export function PaxCheckJourneyToJSONTyped(value?: PaxCheckJourney | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flight_numbers': value['flightNumbers'],
        'departure': PaxCheckDeparturePointToJSON(value['departure']),
        'transit': ((value['transit'] as Array<any>).map(PaxCheckTransitPointToJSON)),
        'arrival': PaxCheckArrivalPointToJSON(value['arrival']),
    };
}

